import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export default function taskGuidanceReducer(
	state = initialState.taskGuidance,
	action
) {
	switch (action.type) {
		case types.GET_TASK_GUIDANCE:
			return _.isEmpty(action.response) ? action.error : action.response;
		case types.RESET_TASK_ATTRIBUTES:
			return initialState.taskGuidance;
		default:
			return state;
	}
}
